@if (loading) {
  <app-loader></app-loader>
}
<div class="row mb-3">
  <div class="col-12 col-lg-6">
    <app-dynamic-breadcrumb [bgColor]="'transparent'" [fontSize]="'14px'"
    [lastLinkColor]="'rgba(196, 196, 205, 0.42)'" [fontColor]="'#c4c4cd'"></app-dynamic-breadcrumb>
  </div>
</div>
<div class="row header col-12">
  {{ editMode ? 'Edit Bundle Type' : 'Add Bundle Type' }}
</div>

@if (bundleType) {
  <div>
    <div class="row">
      <div class="col-12">
        <form #bundleTypeForm="ngForm">
          <div class="row form-row">
            <div class="col-2"><label>Bundle Type Name</label></div>
            <div class="col-3">
              <input type="text" required minlength="4" maxlength="50" [disabled]="editMode"
                [(ngModel)]="bundleType.bundleTypeName" class="bundle-type-form-control"
                #bundleTypeName="ngModel" id="bundleTypeName" name="bundleTypeName"
                pattern="^[A-Za-z0-9 _\-.]*$" trim-text />
                @if (bundleTypeName.invalid && (bundleTypeName.dirty || bundleTypeName.touched)) {
                  <div
                    class="alert alert-danger">
                    @if (bundleTypeName.errors.required) {
                      <div>
                        Bundle Type Name is a mandatory field.
                      </div>
                    }
                    @if (bundleTypeName.errors.pattern) {
                      <div>
                        Bundle Type Name is not valid, as it contains special characters.
                      </div>
                    }
                    @if (bundleTypeName.errors.maxlength) {
                      <div>
                        Bundle Type Name should not exceed 50 characters.
                      </div>
                    }
                    @if (bundleTypeName.errors.minlength) {
                      <div>
                        Bundle Type Name must be at least 4 characters long.
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="row form-row">
              <div class="col-2"><label>Description</label></div>
              <div class="col-3">
                <textarea class="bundle-type-form-control textarea-wrapper"
                  [(ngModel)]="bundleType.bundleTypeDescription" name="bundleTypeDescription"
                  #bundleTypeDescription="ngModel" pattern="[^^/:*|'<>\\{}\[\]]*" trim-text id="bundleTypeDescription"
                maxlength="150"></textarea>
                @if (bundleTypeDescription.invalid && (bundleTypeDescription.dirty || bundleTypeDescription.touched)) {
                  <div
                    class="alert alert-danger">
                    @if (bundleTypeDescription.errors.pattern) {
                      <div>
                        Bundle Type Description is not valid, as it contains special characters.
                      </div>
                    }
                    @if (bundleTypeDescription.errors.maxlength) {
                      <div>
                        Bundle Type Description should not exceed 150 characters.
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </form>
        </div>
      </div>
      @if (reportTreeList) {
        <div class="row">
          <div class="col-12">
            <div class="w-100 justify-content-center info-message">
              Please select reports for the bundle type from the below grid.
            </div>
            <p-treeTable #dtBundleTypes [value]="reportTreeList" selectionMode="checkbox" class="table-irr"
              [(selection)]="selectedNodes" [columns]="reportTreeHeaders" [scrollable]="true"
              [scrollHeight]="'calc(100vh - 500px)'" [paginator]="true" [rows]="8"
              (onNodeSelect)="nodeSelectChange($event)" (onNodeUnselect)="nodeSelectChange($event)" >
              <ng-template pTemplate="paginatorleft">
                <button class="btn btn-clear-filter hvr-shrink" type="button"
                  (click)="dtBundleTypes.reset();clearReportFilters()">
                  <span><i class="fas fa-times mr-1"></i> Clear Filters</span>
                </button>
              </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  @for (col of columns; track col) {
                    <th [ttSortableColumn]="col.field">
                      @if (col.field === 'DisplayName') {
                        <p-treeTableHeaderCheckbox (click)="selectAllReports($event)"></p-treeTableHeaderCheckbox>
                      } @else {
                        <ng-template [ngTemplateOutlet]="notNameColumn"></ng-template>
                      }
                      {{col.header}}
                      <p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
                    </th>
                  }
                </tr>
                <tr>
                  @for (col of columns; track col) {
                    <th>
                      <input type="text" class="w-100" placeholder="Filter Text"
                        [value]="dtBundleTypes.filters && dtBundleTypes.filters[col.field] ? dtBundleTypes.filters[col.field].value: ''"
                        (input)="dtBundleTypes.filter($event.target.value, col.field, 'contains')">
                      </th>
                    }
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                  <tr>
                    <td>
                      <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                      <p-treeTableCheckbox [value]="rowNode" ngDefaultControl>
                      </p-treeTableCheckbox>
                      {{rowData.DisplayName}} {{rowData.selectedCount}}
                    </td>
                    <td>{{rowData.Description}}</td>
                  </tr>
                </ng-template>
              </p-treeTable>
            </div>
          </div>
        }
        <div class="row float-right m-0 d-flex flex-column justify-content-center d-md-block mt-3">
          <button class="btn btn-modal-neg small-font mr-2 hvr-shrink" type="button"
            (click)='backToBundleTypeManagement()'>
            <span>Back to Bundle Type Management</span>
          </button>
          <button class="btn btn-modal-neg small-font mr-2 hvr-shrink" type="button" (click)="clearChanges()"
            id='btnClearChanges'>
            <span>Clear</span>
          </button>
          <button class="btn btn-modal-pos small-font hvr-shrink" type="button" (click)='submit()' id='btnSubmit'
            [disabled]="bundleTypeForm && bundleTypeForm.form ? !bundleTypeForm.form.valid : false">
            <span>Submit</span>
          </button>
        </div>
      </div>
    }